module.exports = __webpack_public_path__ + "static/media/zh-Hant.97118bcf.svg";